import { withSchema } from '@websolutespa/bom-core';
import { Radio as RadioBase } from './radio';
import { RadioGroup } from './radio-group';
import { RadioGroupLabel } from './radio-group-label';
import { RadioIcon } from './radio-icon';

export const Radio = withSchema(
  RadioBase,
  {
    Icon: RadioIcon,
    Group: RadioGroup,
    GroupLabel: RadioGroupLabel,
  });

export type { RadioProps } from './radio';
export type { RadioGroupProps } from './radio-group';
export type { RadioGroupLabelProps } from './radio-group-label';
export type { RadioIconProps } from './radio-icon';

export * from './radio.variants';

